import { Loading, Message } from 'element-ui';
import { randomID } from '@/utils';
import { stockApi } from '@/api';
const websocket = {
  socket: null,
  printerData: {
    cmd: 'getPrinters',
    defaultPrinter: '',
    printers: [],
    requestID: '',
    timer: null,
  },
  loading: null,
  init: callback => {
    if (websocket.socket) {
      // 获取打印列表
      websocket.socket.send(
        JSON.stringify({
          cmd: 'getPrinters',
          requestID: randomID(),
          version: '1.0',
        }),
      );
    } else {
      // 连接打印机
      websocket.connect();
    }
    if (!websocket.socket) {
      Message.error('您的浏览器不支持websocket协议！');
      return;
    }
    websocket.socket.onopen = e => {
      websocket.loading.close();
      // 获取打印列表
      websocket.socket.send(
        JSON.stringify({
          cmd: 'getPrinters',
          requestID: randomID(),
          version: '1.0',
        }),
      );
    };
    websocket.socket.onmessage = res => {
      const data = JSON.parse(res.data);
      if (data.cmd === 'getPrinters') {
        websocket.loading.close();
        websocket.printerData = {
          ...data,
          printers: data.printers.map(e => {
            return {
              label: e.name,
              value: e.name,
            };
          }),
        };
        callback(data);
      }

      if (data.cmd === 'print') {
        websocket.timer = setTimeout(() => {
          Message.error('打印超时，请查看打印组件');
          websocket.loading.close();
        }, 5000);
        callback(data);
      }

      if (data.cmd == 'PrintResultNotify') {
        // 打印成功
        if (data.taskStatus === 'printed') {
          Message.success('打印成功');
          // 通知打印成功
          const LIST = data.printStatus.map(item => {
            return {
              id: item.documentID,
              waybillPrintMessage: null,
              waybillPrintStatus: true,
            };
          });
          // 修改打印状态
          stockApi.getPrintStatusDeliveryOrderWaybills(LIST).then(res => {
            callback(data);
          });
        }
        // 打印失败
        if (data.taskStatus === 'failed') {
          Message.error(`${data.printer}打印失败，请查看打印组件`);
          callback(data);
        }
        clearTimeout(websocket.timer);
        websocket.loading.close();
      }
    };
    websocket.socket.onerror = e => {
      if (e.type === 'error') {
        websocket.socket.close();
        websocket.loading.close();
        websocket.socket = null;
        Message.error('打印组件未开启或无法链接');
        callback(e);
      }
    };
  },
  // 连接打印机
  connect() {
    if (!websocket.socket) {
      // 判断是否连接打印机
      websocket.loading = Loading.service({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
      });
      // 192.168.124.21  127.0.0.1
      websocket.socket = new WebSocket('ws://127.0.0.1:5000');
    }
  },
  // 打印
  print(data) {
    data.task = {
      ...defaultPrintData.task,
      ...data.task,
    };
    const print = Object.assign(defaultPrintData, data);
    websocket.loading = null;
    websocket.loading = Loading.service({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
    });
    websocket.socket.send(JSON.stringify(print));
  },
};

const defaultPrintData = {
  ERPId: 303379400,
  cmd: 'print',
  requestID: '90E06437',
  task: {
    documents: [],
    notifyType: ['print'],
    preview: false,
    previewType: 'image',
    printer: '',
    taskID: '',
  },
  version: '1.0',
};
export default websocket;
